<main class="cv-page" aria-labelledby="cv-title">
  <fieldset class="cv-controls" [disabled]="vinculandoExistentes" [attr.aria-busy]="vinculandoExistentes">
  <header class="cv-hero">
    <div class="cv-hero__copy">
      <div class="cv-eyebrow">
        <span class="cv-platform-mark cv-platform-mark--ifood">iFood</span>
        <span class="cv-platform-mark cv-platform-mark--food99">99Food</span>
      </div>
      <h1 id="cv-title">
        Publicações do catálogo
      </h1>
      <p>Revise itens pendentes, acompanhe envios e publique seu catálogo nos canais de venda.</p>
    </div>
    <div class="cv-hero__art" aria-hidden="true">
      <span class="cv-hero__cube"><i class="fa fa-cube"></i></span>
      <span class="cv-hero__reach">
        <i class="fa fa-bar-chart"></i>
        <strong>Seu catálogo<br>em mais clientes</strong>
      </span>
    </div>
  </header>

  <section class="cv-destination" aria-label="Destino da publicação">
    <div class="cv-destination__column cv-destination__channel">
      <div class="cv-destination__heading">
        <span class="cv-destination__icon fa fa-shopping-bag" aria-hidden="true"></span>
        <div>
          <strong>Canal de venda</strong>
          <small>Selecione o canal onde seu catálogo será publicado.</small>
        </div>
      </div>
      <label class="sr-only" for="cv-channel-select">Canal de venda</label>
      <select id="cv-channel-select"
        [disabled]="desativandoCanal || publicando || temSalvamento || aplicandoMassa"
        [ngModel]="canalSelecionadoId" (ngModelChange)="selecioneCanal($event)">
        <option [ngValue]="null">Selecione um canal</option>
        <option *ngFor="let canal of canaisDisponiveis" [ngValue]="canal.id">
          {{ canal.nome }}
          {{ canal.ativo ? '' : ' (inativo)' }}
        </option>
      </select>
      <small class="cv-destination__hint">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Preços e disponibilidade específicos deste canal.
      </small>
    </div>

    <div class="cv-destination__column cv-destination__catalog">
      <div class="cv-destination__heading">
        <span class="cv-destination__icon fa fa-file-text-o" aria-hidden="true"></span>
        <div>
          <strong>Catálogo local</strong>
          <small>Identificação do catálogo neste canal.</small>
        </div>
      </div>
      <strong class="cv-destination__catalog-name">
        {{ canalSelecionado?.catalogoId ? ('Catálogo #' + canalSelecionado?.catalogoId) : 'Selecione um canal' }}
      </strong>
      <small class="cv-destination__catalog-id" *ngIf="canalSelecionado?.catalogoExternoId">
        ID interno: {{ canalSelecionado.catalogoExternoId }}
      </small>
    </div>

    <div class="cv-destination__column cv-destination__actions">
      <div class="cv-destination__heading">
        <span class="cv-destination__icon fa fa-cog" aria-hidden="true"></span>
        <div>
          <strong>Status e ações do canal</strong>
          <small>Gerencie o status e configurações deste canal.</small>
        </div>
      </div>
      <div class="cv-channel-status" [class.is-active]="canalSelecionado?.ativo"
        [class.is-empty]="!canalSelecionado">
        <span class="cv-status-dot" [class.is-active]="canalSelecionado?.ativo"></span>
        <span>{{ !canalSelecionado ? 'Nenhum canal selecionado' :
          (canalSelecionado.ativo ? 'Canal ativo' : 'Canal inativo') }}</span>
      </div>
      <div class="cv-channel-actions" *ngIf="podeGerenciarCanal">
        <ng-container *ngIf="canalSelecionado">
          <button type="button" class="cv-channel-action" *ngIf="!canalSelecionado.ativo"
            (click)="ativeCanal()" [disabled]="desativandoCanal">
            <span class="fa fa-power-off"></span> Ativar
          </button>
          <button type="button" class="cv-channel-action" *ngIf="canalSelecionado.ativo"
            (click)="confirmarDesativacao = !confirmarDesativacao" [disabled]="desativandoCanal">
            <span class="fa fa-power-off"></span> Desativar
          </button>
          <button type="button" class="cv-channel-action" (click)="abraRemocaoCanal()"
            [disabled]="desativandoCanal || publicando || temSalvamento || aplicandoMassa || vinculandoExistentes">
            <span class="fa fa-trash"></span> Remover canal
          </button>
          <button type="button" class="cv-channel-action" (click)="abraConfiguracaoPrecoCanal()"
            [disabled]="publicando || temSalvamento || aplicandoMassa">
            <span class="fa fa-percent"></span>
            {{ canalSelecionado.percentualPrecoPadrao == null ? 'Preços iguais ao MeuCardápio' : ('Ajuste de ' + canalSelecionado.percentualPrecoPadrao + '%') }}
          </button>
        </ng-container>
        <button type="button" class="cv-button cv-button--primary cv-new-channel-button"
          [disabled]="salvandoCanal" (click)="abraNovoCanal()">
          <span class="fa fa-plus"></span> Novo canal
        </button>
      </div>
    </div>
  </section>

  <section class="cv-channel-price-config" *ngIf="podeGerenciarCanal && configurandoPrecoCanal && canalSelecionado">
    <div>
      <strong>Formação de preços do canal</strong>
      <label class="cv-price-equal-option">
        <input type="checkbox" [ngModel]="!precoIgualCanal"
          (ngModelChange)="precoIgualCanal = !$event" [disabled]="salvandoPrecoCanal">
        Usar percentual sobre o preço do Promokit
      </label>
      <label class="cv-field" *ngIf="!precoIgualCanal">
        <span>Percentual sobre o MeuCardápio</span>
        <div class="cv-percent-input"><input type="number" min="-100" max="1000" step="0.1"
          [(ngModel)]="percentualCanal" [disabled]="salvandoPrecoCanal"><span>%</span></div>
      </label>
      <small *ngIf="precoIgualCanal">Sem percentual, o canal acompanha o preço do Promokit. Alterações geram pendência para revisão e publicação.</small>
      <small>A regra pode ser ativada ou desativada a qualquer momento e vale para produtos e adicionais sem preço específico neste canal.</small>
      <div class="cv-alert cv-alert--error" *ngIf="erroPrecoCanal" role="alert">{{ erroPrecoCanal }}</div>
    </div>
    <div class="cv-channel-price-config__actions">
      <button type="button" class="cv-button cv-button--outline" (click)="fecheConfiguracaoPrecoCanal()"
        [disabled]="salvandoPrecoCanal">Cancelar</button>
      <button type="button" class="cv-button cv-button--primary" (click)="salveConfiguracaoPrecoCanal()"
        [disabled]="salvandoPrecoCanal">{{ salvandoPrecoCanal ? 'Salvando…' : 'Salvar regra' }}</button>
    </div>
  </section>

  <section class="cv-vinculacao" *ngIf="vinculandoExistentes || resultadoVinculacao || erroVinculacao" aria-label="Vinculação de produtos existentes">
    <p *ngIf="vinculandoExistentes" role="status">Buscando produtos e adicionais pelos IDs antigos. Nenhuma alteração será enviada ao {{ nomePlataforma }}.</p>
    <div class="cv-alert cv-alert--warning" *ngIf="erroVinculacao" role="status">
      <span>{{ erroVinculacao }}</span>
      <button type="button" class="cv-link" [disabled]="!canalSelecionado?.ativo || publicando || temSalvamento || aplicandoMassa" (click)="vinculeExistentes()">Tentar novamente</button>
    </div>
    <ng-container *ngIf="resultadoVinculacao as resultado">
      <p role="status"><strong>Vinculação concluída:</strong> {{ resultado.vinculados }} vinculado(s), {{ resultado.jaVinculados }} já vinculado(s),
        {{ resultado.naoEncontrados }} não encontrado(s), {{ resultado.ambiguos }} ambíguo(s) e {{ resultado.falhas }} falha(s).</p>
      <p *ngIf="!resultado.total">Nenhum produto com ID antigo do {{ nomePlataforma }} foi encontrado no cadastro local.</p>
      <details *ngIf="resultado.resultados.length"><summary>Ver resultado por produto</summary>
        <article *ngFor="let produto of resultado.resultados">
          <strong>{{ produto.nome }} · #{{ produto.produtoId }}</strong><span>{{ produto.mensagem }}</span>
        </article>
      </details>
    </ng-container>
  </section>

  <div class="cv-alert cv-alert--warning" *ngIf="podeGerenciarCanal && confirmarDesativacao">
    <span>Desativar este canal? Novas publicações ficarão indisponíveis enquanto ele estiver inativo.</span>
    <button type="button" class="cv-button cv-button--outline" [disabled]="desativandoCanal" (click)="desativeCanal()">
      {{ desativandoCanal ? 'Desativando…' : 'Desativar canal' }}
    </button>
    <button type="button" class="cv-link" [disabled]="desativandoCanal" (click)="confirmarDesativacao = false">Cancelar</button>
  </div>

  <div class="cv-modal-backdrop" *ngIf="podeGerenciarCanal && confirmarRemocao" (click)="fecheRemocaoCanal()"></div>
  <section class="cv-modal cv-modal--remove-channel" *ngIf="podeGerenciarCanal && confirmarRemocao" #modalRemocaoCanal
    role="dialog" aria-modal="true" aria-labelledby="cv-remove-channel-title"
    aria-describedby="cv-remove-channel-description" tabindex="-1"
    [attr.aria-busy]="desativandoCanal" (keydown)="teclaRemocaoCanal($event)">
    <header>
      <h2 id="cv-remove-channel-title">Remover canal de venda</h2>
      <button type="button" aria-label="Fechar confirmação de remoção" [disabled]="desativandoCanal"
        (click)="fecheRemocaoCanal()">×</button>
    </header>
    <div class="cv-modal__body">
      <div id="cv-remove-channel-description">
        <p>Remover o canal <strong>“{{ canalSelecionado?.nome }}”</strong>?</p>
        <p class="cv-remove-channel-warning"><strong>Esta ação não pode ser desfeita.</strong></p>
        <p>As publicações pendentes serão canceladas e o histórico será preservado.
          Os produtos no {{ nomePlataforma }} não serão alterados.</p>
        <p>Você poderá criar um novo canal para o mesmo destino, mas isso não restaura este canal nem suas pendências.</p>
      </div>
      <div class="cv-alert cv-alert--error" role="alert" *ngIf="erroRemocaoCanal">
        <span>{{ erroRemocaoCanal }}</span>
      </div>
    </div>
    <footer>
      <button type="button" class="cv-button cv-button--outline" data-cancelar-remocao
        [disabled]="desativandoCanal" (click)="fecheRemocaoCanal()">Cancelar</button>
      <button type="button" class="cv-button cv-button--danger" [disabled]="desativandoCanal" (click)="removaCanal()">
        <span class="fa" [class.fa-trash]="!desativandoCanal" [class.fa-spinner]="desativandoCanal"
          [class.fa-spin]="desativandoCanal" aria-hidden="true"></span>
        {{ desativandoCanal ? 'Removendo…' : 'Remover canal' }}
      </button>
    </footer>
  </section>

  <div class="cv-modal-backdrop" *ngIf="podeGerenciarCanal && mostrarNovoCanal" (click)="fecheNovoCanal()"></div>
  <section class="cv-modal cv-modal--new-channel" *ngIf="podeGerenciarCanal && mostrarNovoCanal" #formularioNovoCanal
    role="dialog" aria-modal="true" aria-labelledby="cv-new-channel-title" tabindex="-1"
    [attr.aria-busy]="salvandoCanal" (keydown)="teclaNovoCanal($event)">
    <header>
      <h2 id="cv-new-channel-title">Criar canal de venda</h2>
      <button type="button" aria-label="Fechar cadastro de canal" [disabled]="salvandoCanal" (click)="fecheNovoCanal()">×</button>
    </header>
    <div class="cv-modal__body">
    <div class="cv-new-channel">
    <label class="cv-field">
      <span>Integração Autorizada</span>
      <select [disabled]="salvandoCanal" [ngModel]="destinoNovoCanalId" (ngModelChange)="selecioneDestinoNovoCanal($event)">
        <option [ngValue]="null">Selecione</option>
        <option *ngFor="let destino of destinos?.destinos" [ngValue]="(destino.plataforma || 'IFOOD') + ':' + destino.id">
          {{ destino.plataforma === 'FOOD99' ? '99Food' : 'iFood' }} · {{ destino.nome || destino.merchantId }} · {{ destino.merchantId }}
        </option>
      </select>
    </label>
    <label class="cv-field">
      <span>Catálogo</span>
      <select *ngIf="catalogosNovoCanal.length" [disabled]="salvandoCanal" [(ngModel)]="catalogoExternoNovoCanal">
        <option *ngFor="let catalogo of catalogosNovoCanal" [ngValue]="catalogo.id">
          {{ catalogo.nome }} · {{ catalogo.id || 'sem identificador' }}
        </option>
      </select>
      <input *ngIf="!catalogosNovoCanal.length" type="text" maxlength="120"
        [(ngModel)]="catalogoExternoNovoCanal" placeholder="Catálogo da integração"
        [disabled]="carregandoCatalogosNovoCanal || salvandoCanal">
      <small *ngIf="carregandoCatalogosNovoCanal">Carregando catálogos da loja…</small>
    </label>
    <label class="cv-field">
      <span>Nome do Canal</span>
      <input type="text" maxlength="120" [disabled]="salvandoCanal" [(ngModel)]="nomeNovoCanal" placeholder="Ex.: Loja Centro">
    </label>
    <label class="cv-price-equal-option">
      <input type="checkbox" [(ngModel)]="precoIgualNovoCanal"
        (ngModelChange)="$event && (percentualNovoCanal = null)" [disabled]="salvandoCanal">
      Preços serão os mesmos do MeuCardápio
    </label>
    <label class="cv-field" *ngIf="!precoIgualNovoCanal">
      <span>Percentual sobre o MeuCardápio</span>
      <div class="cv-percent-input"><input type="number" min="-100" max="1000" step="0.1"
        [(ngModel)]="percentualNovoCanal" [disabled]="salvandoCanal"><span>%</span></div>
    </label>
    </div>

  <div class="cv-alert cv-alert--warning" role="status" *ngIf="catalogoNovoCanalSemIdentificador">
    <span class="fa fa-exclamation-triangle"></span>
    <span>{{ avisoCatalogoSemIdentificador }}</span>
  </div>
  <div class="cv-alert cv-alert--error" role="alert" *ngIf="erroNovoCanal">
    <span class="fa fa-exclamation-circle"></span>
    <span>{{ erroNovoCanal }}</span>
    <button type="button" aria-label="Fechar erro de criação do canal" (click)="erroNovoCanal = ''">×</button>
  </div>
    </div>
    <footer>
      <button type="button" class="cv-button cv-button--outline" [disabled]="salvandoCanal" (click)="fecheNovoCanal()">Cancelar</button>
      <button type="button" class="cv-button cv-button--primary" [disabled]="salvandoCanal || carregandoCatalogosNovoCanal || catalogoNovoCanalSemIdentificador" (click)="crieCanal()">
        {{ salvandoCanal ? 'Criando…' : 'Criar e ativar' }}
      </button>
    </footer>
  </section>

  <div class="cv-modal-backdrop" *ngIf="mostrarVinculacao" (click)="fecheVinculacao()"></div>
  <section class="cv-modal cv-modal--link-products" *ngIf="mostrarVinculacao" #modalVinculacao
    role="dialog" aria-modal="true" aria-labelledby="cv-link-products-title" tabindex="-1"
    [attr.aria-busy]="carregandoProdutosVinculacao || vinculandoExistentes"
    (keydown)="teclaVinculacao($event)">
    <header>
      <div>
        <h2 id="cv-link-products-title">Vincular produtos existentes no {{ nomePlataforma }}</h2>
        <p>Associe os produtos já existentes no {{ nomePlataforma }} a este canal. Nenhum produto será publicado.</p>
      </div>
      <button type="button" aria-label="Fechar vinculação" [disabled]="vinculandoExistentes"
        (click)="fecheVinculacao()">×</button>
    </header>
    <div class="cv-modal__body">
      <section class="cv-link-summary" aria-label="Resumo dos vínculos do canal">
        <article><strong>{{ quantidadeVinculadosCanal }}</strong><span>Já vinculados</span></article>
        <article><strong>{{ quantidadeSemVinculoCanal }}</strong><span>Sem vínculo</span></article>
      </section>

      <div class="cv-loading" *ngIf="carregandoProdutosVinculacao">
        <span class="fa fa-spinner fa-spin"></span> Carregando produtos sem vínculo…
      </div>
      <div class="cv-alert cv-alert--error" role="alert" *ngIf="erroProdutosVinculacao">
        <span>{{ erroProdutosVinculacao }}</span>
        <button type="button" class="cv-link" (click)="carregueProdutosVinculacao()">Tentar novamente</button>
      </div>
      <div class="cv-alert cv-alert--info" role="status" *ngIf="carregandoAnaliseVinculacao">
        <span class="fa fa-spinner fa-spin"></span> Analisando vínculos com o catálogo do {{ nomePlataforma }}…
      </div>
      <div class="cv-alert cv-alert--error" role="alert" *ngIf="erroAnaliseVinculacao">
        <span>{{ erroAnaliseVinculacao }}</span>
        <button type="button" class="cv-link" (click)="carreguePreviaVinculacao()">Tentar novamente</button>
      </div>
      <div class="cv-alert cv-alert--success" role="status" *ngIf="resultadoVinculacao && !vinculandoExistentes">
        <span>Última tentativa: {{ resultadoVinculacao.vinculados }} vinculado(s),
          {{ resultadoVinculacao.naoEncontrados }} não encontrado(s),
          {{ resultadoVinculacao.ambiguos + resultadoVinculacao.falhas }} com problema.</span>
      </div>

      <div class="cv-empty cv-link-products-empty"
        *ngIf="!carregandoProdutosVinculacao && !erroProdutosVinculacao && paginaVinculacao && !paginaVinculacao.total">
        <span class="fa fa-check-circle"></span>
        <h3>Nenhum produto para vincular</h3>
        <p>Todos os produtos deste catálogo já possuem vínculo com o canal.</p>
      </div>

      <div class="cv-link-workspace" *ngIf="!carregandoProdutosVinculacao && paginaVinculacao?.total">
        <aside class="cv-link-sidebar" aria-label="Produtos locais sem vínculo">
          <div class="cv-link-sidebar__search">
            <label for="cv-link-search">Buscar produto local</label>
            <input id="cv-link-search" type="search" [(ngModel)]="buscaProdutosVinculacao"
              placeholder="Nome, código PDV ou categoria">
            <small>{{ paginaVinculacao?.itens.length || 0 }} produtos em {{ categoriasProdutosVinculacao.length }} categorias</small>
          </div>
          <p *ngIf="!categoriasProdutosVinculacao.length" class="cv-link-sidebar__empty">Nenhum produto encontrado.</p>
          <section *ngFor="let categoria of categoriasProdutosVinculacao" class="cv-link-category">
            <button type="button" class="cv-link-category__toggle"
              [attr.aria-expanded]="!categoriaVinculacaoRecolhida(categoria.chave)"
              (click)="altereCategoriaVinculacao(categoria.chave)">
              <span class="fa" [class.fa-chevron-right]="categoriaVinculacaoRecolhida(categoria.chave)"
                [class.fa-chevron-down]="!categoriaVinculacaoRecolhida(categoria.chave)"></span>
              <strong>{{ categoria.nome }}</strong><small>{{ categoria.produtos.length }}</small>
            </button>
            <div *ngIf="!categoriaVinculacaoRecolhida(categoria.chave)">
              <button type="button" *ngFor="let produto of categoria.produtos"
                class="cv-link-sidebar__product" [class.is-active]="produtoSelecionadoVinculacaoId === produto.produtoId"
                [disabled]="vinculandoExistentes" (click)="selecioneProdutoVinculacao(produto.produtoId)">
                <span class="cv-link-product__image">
                  <img *ngIf="produto.imagem && !imagensComErro.has(produto.imagem)"
                    [src]="produto.imagem" [alt]="produto.nome" (error)="imagensComErro.add(produto.imagem)">
                  <span class="fa fa-image" *ngIf="!produto.imagem || imagensComErro.has(produto.imagem)"></span>
                </span>
                <span class="cv-link-sidebar__identity"><strong>{{ produto.nome }}</strong>
                  <small>#{{ produto.produtoId }} · {{ produto.categoria?.nome || 'Sem categoria' }}</small></span>
                <span class="cv-link-sidebar__meta"><small>PDV {{ produto.codigoPdv || '—' }}</small>
                  <strong>{{ produto.preco.base != null
                    ? (produto.preco.base | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</strong>
                  <span class="cv-badge cv-link-sidebar__status" [ngClass]="classeBadgeVinculacao(produto.produtoId)">
                    {{ rotuloProdutoVinculacao(produto.produtoId) }}</span></span>
              </button>
            </div>
          </section>
        </aside>

        <div class="cv-link-detail" *ngIf="produtoSelecionadoVinculacao as produto; else cvEscolhaProduto">
          <div class="cv-link-parent-card">
            <div class="cv-link-parent-card__heading">
              <small>Vínculo do produto pai</small>
              <strong class="cv-badge" [ngClass]="classeBadgeVinculacao(produto.produtoId)">
                {{ rotuloProdutoVinculacao(produto.produtoId) }}</strong>
            </div>
            <div class="cv-link-parent-card__row">
              <div class="cv-link-parent-card__local">
                <span class="cv-link-remote__image">
                  <img *ngIf="produto.imagem && !imagensComErro.has(produto.imagem)" [src]="produto.imagem"
                    [alt]="produto.nome" (error)="imagensComErro.add(produto.imagem)">
                  <span *ngIf="!produto.imagem || imagensComErro.has(produto.imagem)" class="fa fa-image"></span>
                </span>
                <div><small>No Promokit</small><h3>{{ produto.nome }}</h3>
                  <p>PDV {{ produto.codigoPdv || 'não informado' }} · Preço
                    {{ produto.preco.base != null ? (produto.preco.base | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</p>
                  <span class="cv-link-category-badge">Categoria: {{ produto.categoria?.nome || 'Sem categoria' }}</span>
                </div>
              </div>
              <div class="cv-link-parent-card__connector"><span aria-hidden="true">↔</span>
                <small [class.is-suggested]="!produtosIfoodSelecionados[produto.produtoId] && produtoAssociadoVinculacao(produto.produtoId)">
                  {{ produtosIfoodSelecionados[produto.produtoId] ? 'Manual' :
                  (produtoAssociadoVinculacao(produto.produtoId) ? 'Sugerido' : 'Pendente') }}</small>
              </div>
              <div class="cv-link-remote" *ngIf="!ignoradosVinculacao.has(produto.produtoId); else cvProdutoIgnorado">
            <div class="cv-link-remote__heading"><strong>Correspondente no {{ nomePlataforma }}</strong>
              <button type="button" class="cv-link" [disabled]="carregandoAnaliseVinculacao || vinculandoExistentes"
                (click)="abraSeletorProdutoIfood(produto.produtoId)">
                {{ produtosIfoodSelecionados[produto.produtoId] ? 'Trocar produto' : 'Selecionar produto' }}
              </button></div>
            <ng-container *ngIf="produtoExternoVinculacao(produto.produtoId) as externo; else cvSemProdutoExterno">
              <div class="cv-link-remote__product">
                <span class="cv-link-remote__image">
                  <img *ngIf="externo.imagem && !imagensComErro.has(externo.imagem)" [src]="externo.imagem"
                    [alt]="externo.nome" (error)="imagensComErro.add(externo.imagem)">
                  <span *ngIf="!externo.imagem || imagensComErro.has(externo.imagem)" class="fa fa-image"></span>
                </span>
                <div><strong>{{ externo.nome }}</strong>
                  <small>PDV {{ externo.codigoPdv || 'não informado' }} · Preço
                    {{ externo.preco != null ? (externo.preco | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</small>
                  <span class="cv-link-category-badge cv-link-category-badge--externo">
                    Categoria: {{ externo.categoria?.nome || 'Sem categoria' }}</span>
                </div>
              </div>
              <div class="cv-link-category-warning" *ngIf="categoriasVinculacaoDiferentes(produto, externo)">
                <span class="fa fa-exclamation-triangle" aria-hidden="true"></span>
                <span><strong>Categorias diferentes:</strong> Promokit: {{ produto.categoria?.nome || 'Sem categoria' }} ·
                  {{ nomePlataforma }}: {{ externo.categoria?.nome || 'Sem categoria' }}.
                  A vinculação não altera as categorias.</span>
              </div>
            </ng-container>
            <ng-template #cvSemProdutoExterno>
              <ng-container *ngIf="previaDoProduto(produto.produtoId) as previa; else cvAguardandoAnalise">
                <span class="cv-link-match">{{ previa.situacao === 'AMBIGUO'
                  ? 'Mais de uma correspondência possível' : 'Nenhum produto correspondente' }}</span>
              </ng-container>
            </ng-template>
            <ng-template #cvAguardandoAnalise><small>{{ carregandoAnaliseVinculacao
              ? 'Analisando catálogo…' : (erroAnaliseVinculacao || 'Nenhuma correspondência encontrada') }}</small></ng-template>
            <div *ngIf="seletorProdutoIfoodAberto === produto.produtoId" class="cv-combo-produto-externo">
              <button *ngIf="produtosIfoodSelecionados[produto.produtoId]" type="button"
                class="cv-combo-produto-externo__cancelar" (click)="canceleSelecaoProdutoIfood(produto.produtoId)">
                Cancelar seleção manual
              </button>
              <small *ngIf="previaDoProduto(produto.produtoId)?.situacao === 'AMBIGUO'"
                class="cv-combo-produto-externo__ajuda">Correspondências candidatas para este produto:</small>
              <input class="cv-combo-produto-externo__busca" type="search" [(ngModel)]="produtoIfoodBusca"
                placeholder="Buscar por nome, PDV ou ID">
              <div *ngIf="!catalogoExternoVinculacao.length" class="cv-combo-produto-externo__vazio">
                {{ erroAnaliseVinculacao || 'Nenhum produto sem vínculo disponível no catálogo do ' + nomePlataforma + '.' }}
              </div>
              <div *ngFor="let categoria of categoriasCatalogoExterno(produto.produtoId)" class="cv-combo-produto-externo__grupo">
                <strong>{{ categoria }}</strong>
                <button type="button" *ngFor="let item of produtosExternosDaCategoria(categoria, produto.produtoId)"
                  class="cv-combo-produto-externo__item" (click)="selecioneProdutoIfood(produto.produtoId, item)">
                  <img *ngIf="item.imagem" [src]="item.imagem" [alt]="item.nome">
                  <span><strong>{{ item.nome }}</strong>
                    <small *ngIf="item.codigoPdv">PDV: {{ item.codigoPdv }}</small>
                    <small>{{ item.preco | currency:'BRL':'symbol':'1.2-2':'pt' }}</small>
                    </span>
                </button>
              </div>
              <div *ngIf="catalogoExternoVinculacao.length && !categoriasCatalogoExterno(produto.produtoId).length"
                class="cv-combo-produto-externo__vazio">Nenhum produto sem vínculo disponível para seleção.</div>
            </div>
          </div>
              <ng-template #cvProdutoIgnorado><div class="cv-link-parent-card__ignored">Sem vínculo nesta análise</div></ng-template>
            </div>
          </div>

          <div class="cv-link-detail__actions">
            <button type="button" class="cv-button cv-button--outline"
              *ngIf="!produtoAssociadoVinculacao(produto.produtoId) && !ignoradosVinculacao.has(produto.produtoId) && !carregandoAnaliseVinculacao"
              (click)="naoVinculeProduto(produto.produtoId)">Não vincular este produto</button>
            <button type="button" class="cv-button cv-button--outline" *ngIf="ignoradosVinculacao.has(produto.produtoId)"
              (click)="volteAVincularProduto(produto.produtoId)">Voltar a vincular</button>
            <button type="button" class="cv-button cv-button--primary" *ngIf="mesclagensRevisadas[produto.produtoId]"
              [disabled]="vinculandoExistentes || carregandoMesclagem || statusVinculacaoProdutos[produto.produtoId]?.situacao === 'VINCULADO'"
              (click)="vinculeProdutoDoModal(produto.produtoId)">Vincular agora</button>
          </div>
          <p *ngIf="ignoradosVinculacao.has(produto.produtoId)" class="cv-link-detail__hint">
            Ignorado somente nesta análise; nenhum vínculo foi criado.
          </p>
          <p *ngIf="statusVinculacaoProdutos[produto.produtoId] as status" class="cv-vinculacao-status"
            [class.cv-vinculacao-status--erro]="status.situacao === 'FALHA'"
            [class.cv-vinculacao-status--sucesso]="status.situacao === 'VINCULADO'">
            {{ status.mensagem }}
          </p>
          <div *ngIf="carregandoMesclagem && produtoAssociadoVinculacao(produto.produtoId)" class="cv-loading">
            <span class="fa fa-spinner fa-spin"></span> Analisando adicionais e opções…
          </div>
          <p *ngIf="erroMesclagem" class="cv-alert cv-alert--error" role="alert">{{ erroMesclagem }}</p>
          <button *ngIf="erroMesclagem && produtoAssociadoVinculacao(produto.produtoId)" type="button"
            class="cv-button cv-button--outline" (click)="abraMesclagem(produto.produtoId)">Tentar novamente</button>
          <app-mesclagem-produto-canal-venda
            *ngIf="mesclagem && mesclagem.produto.local.id === produto.produtoId"
            [previa]="mesclagem" [mostrarVoltar]="false" [nomePlataforma]="nomePlataforma"
            [revisao]="rascunhosVinculacao[produto.produtoId] || mesclagensRevisadas[produto.produtoId]?.escolhas || null"
            (confirmar)="confirmeMesclagem($event)">
          </app-mesclagem-produto-canal-venda>
        </div>
        <ng-template #cvEscolhaProduto><div class="cv-link-detail cv-link-detail--empty">Escolha um produto à esquerda.</div></ng-template>
      </div>
      <small>Vincular todos considera apenas os produtos com vínculos revisados.</small>
    </div>
    <footer>
      <button type="button" class="cv-button cv-button--outline" [disabled]="vinculandoExistentes"
        (click)="fecheVinculacao()">Fechar</button>
      <button type="button" class="cv-button cv-button--primary"
        [disabled]="vinculandoExistentes || carregandoMesclagem || carregandoProdutosVinculacao || carregandoAnaliseVinculacao || !quantidadeVinculaveis"
        (click)="vinculeTodosDoModal()">
        <span class="fa" [class.fa-link]="!vinculandoExistentes" [class.fa-spinner]="vinculandoExistentes"
          [class.fa-spin]="vinculandoExistentes"></span>
        {{ vinculandoExistentes ? 'Vinculando…' : 'Vincular todos ' + quantidadeVinculaveis + ' produtos' }}
      </button>
    </footer>
  </section>

  <div class="cv-alert cv-alert--error" role="alert" *ngIf="erro">
    <span class="fa fa-exclamation-circle"></span>
    <span>{{ erro }}</span>
    <button type="button" aria-label="Fechar aviso" (click)="erro = ''">×</button>
  </div>
  <div class="cv-alert cv-alert--warning" role="status" *ngIf="avisoRuntime">
    <span class="fa fa-clock-o"></span> {{ avisoRuntime }}
  </div>
  <div class="cv-alert cv-alert--warning" *ngIf="destinos && !publicacaoConfigurada">
    <span class="fa fa-info-circle"></span>
    O processamento de publicações não está configurado neste ambiente. Você ainda pode revisar o catálogo.
  </div>
  <div class="cv-alert cv-alert--warning" *ngIf="canalSelecionado && !canalSelecionado.ativo">
    <span class="fa fa-lock"></span>
    Ative o canal para configurar, revisar ou publicar produtos.
  </div>

  <div class="cv-loading" *ngIf="carregando" aria-live="polite">
    <span class="fa fa-spinner fa-spin"></span> Carregando canais de venda…
  </div>

  <ng-container *ngIf="!carregando && canalSelecionadoId">
    <nav class="cv-tabs" aria-label="Áreas de publicação">
      <button type="button" [class.is-active]="aba === 'PENDENTES'" (click)="novaPublicacao()">
        <i class="fa fa-cube" aria-hidden="true"></i> Produtos no canal
      </button>
      <button type="button" [class.is-active]="aba === 'PROCESSANDO'" (click)="selecioneAbaEnvios()">
        <i class="fa fa-file-text-o" aria-hidden="true"></i> Envios e erros
        <span>{{ publicacoesComProblema }}</span>
      </button>
    </nav>

    <ng-container *ngIf="aba === 'PROCESSANDO'">
      <section class="cv-sends-heading">
        <div>
          <h2>Envios e erros</h2>
          <p>Acompanhe os resultados e resolva itens que precisam de atenção.</p>
        </div>
        <button type="button" class="cv-button cv-button--outline" [disabled]="atualizandoAndamento"
          (click)="atualizeResultados()">
          <span class="fa" [class.fa-spinner]="atualizandoAndamento" [class.fa-spin]="atualizandoAndamento"
            [class.fa-refresh]="!atualizandoAndamento"></span>
          Atualizar resultados
        </button>
      </section>

      <section class="cv-publication-metrics" aria-label="Resumo das publicações">
        <article><span class="cv-metric-icon fa fa-cube"></span><div><strong>{{ publicacoes.length }}</strong><b>Total de publicações</b><small>Publicações enviadas para o canal.</small></div></article>
        <article><span class="cv-metric-icon is-waiting fa fa-clock-o"></span><div><strong>{{ publicacoesEmAndamento }}</strong><b>Em andamento</b><small>Publicações aguardando conclusão.</small></div></article>
        <article><span class="cv-metric-icon is-success fa fa-check"></span><div><strong>{{ publicacoesConcluidas }}</strong><b>Concluídas</b><small>Finalizadas com sucesso.</small></div></article>
        <article><span class="cv-metric-icon is-error fa fa-exclamation-triangle"></span><div><strong>{{ publicacoesComProblema }}</strong><b>Com problema</b><small>Publicações que requerem atenção.</small></div></article>
      </section>

      <div class="cv-publication-layout">
        <section class="cv-progress-panel">
          <ng-container *ngIf="publicacao; else semPublicacao">
            <header class="cv-publication-title">
              <div>
                <div class="cv-publication-title__line">
                  <h2>Publicação #{{ publicacao.id }}</h2>
                  <span class="cv-publication-status" [class.is-error]="publicacao.situacao === 'CONCLUIDA_COM_ERROS'"
                    [class.is-success]="publicacao.situacao === 'CONCLUIDA'"
                    [class.is-waiting]="!acompanhamentoTerminal">{{ rotuloSituacaoLote(publicacao.situacao) }}</span>
                </div>
                <p *ngIf="acompanhamentoTerminal">
                  Finalizada em {{ (publicacao.concluidoEm || publicacao.criadoEm) | date:'dd/MM/yyyy HH:mm' }} ·
                  {{ resumoFinalizacaoPublicacao() }}
                </p>
                <p *ngIf="!acompanhamentoTerminal">
                  Iniciada em {{ (publicacao.iniciadoEm || publicacao.criadoEm) | date:'dd/MM/yyyy HH:mm' }} · aguardando conclusão.
                </p>
              </div>
            </header>

            <div class="cv-query-result" role="status" aria-live="polite" *ngIf="resultadoConsultaAndamento">
              <span class="fa" [class.fa-check-circle]="!erroConsultaAndamento"
                [class.fa-exclamation-triangle]="erroConsultaAndamento"></span>
              {{ resultadoConsultaAndamento }}
              <span *ngIf="ultimaConsultaAndamento && !erroConsultaAndamento">Atualizado às {{ ultimaConsultaAndamento | date:'HH:mm:ss' }}.</span>
            </div>

            <div class="cv-alert cv-alert--warning" *ngFor="let aviso of publicacao.avisosImagens" role="status">
              Imagem recusada na auditoria 99Food: {{ aviso }}
            </div>
            <div class="cv-publication-steps" [class.is-terminal]="acompanhamentoTerminal"
              [class.has-error]="publicacao.situacao === 'CONCLUIDA_COM_ERROS'">
              <div><span class="fa fa-check"></span><strong>Envio realizado</strong></div>
              <div><span class="fa fa-check"></span><strong>Retorno consultado</strong></div>
              <div><span class="fa" [class.fa-exclamation-triangle]="publicacao.situacao === 'CONCLUIDA_COM_ERROS'"
                [class.fa-check]="publicacao.situacao === 'CONCLUIDA'" [class.fa-clock-o]="!acompanhamentoTerminal"></span>
                <strong>{{ rotuloSituacaoLote(publicacao.situacao) }}</strong></div>
            </div>

            <div class="cv-progress-counters">
              <div><strong>{{ publicacao.quantidadeItens }}</strong><span>Total de itens</span></div>
              <div class="is-success"><strong>{{ publicacao.quantidadeSucessos }}</strong><span>Concluídos</span></div>
              <div class="is-error"><strong>{{ publicacao.quantidadeErros }}</strong><span>Requer atenção</span></div>
              <div><strong>{{ rotuloSituacaoLote(publicacao.situacao) }}</strong><span>Situação do lote</span></div>
            </div>

            <h3 class="cv-items-title">Itens do lote ({{ publicacao.itens.length }})</h3>
            <div class="cv-execution-list">
              <article *ngFor="let item of publicacao.itens; trackBy: trackPublicacao" class="cv-publication-item">
                <div class="cv-publication-item__identity">
                  <div class="cv-publication-item__image">
                    <ng-container *ngIf="imagemItem(item) as imagem">
                      <img *ngIf="!imagensComErro.has(imagem)" [src]="imagem" [alt]="item.produtoNome || 'Produto'"
                        (error)="imagensComErro.add(imagem)">
                    </ng-container>
                    <span *ngIf="!imagemItem(item) || imagensComErro.has(imagemItem(item))" class="fa fa-cube"></span>
                  </div>
                  <div>
                    <strong>{{ item.produtoNome || ('Produto #' + (item.produtoId || item.alvoCanalVendaId)) }}</strong>
                    <small>Item #{{ item.id }} · {{ rotuloOperacaoItem(item.operacao) }}</small>
                    <span class="cv-item-status" [class.is-error]="item.situacao === 'ERRO'"
                      [class.is-success]="item.situacao === 'SUCESSO'">{{ rotuloSituacaoItem(item) }}</span>
                    <p>{{ mensagemItem(item) }}</p>
                    <div class="cv-technical-details" *ngIf="detalhesTecnicosPublicacao.has(item.id)">
                      <strong>Detalhes técnicos</strong>
                      <span *ngIf="item.codigoErro">Código: {{ item.codigoErro }}</span>
                      <span>{{ item.mensagemErro || 'Nenhum detalhe adicional informado pelo canal.' }}</span>
                    </div>
                  </div>
                </div>
                <div class="cv-publication-item__actions">
                  <span *ngIf="item.situacao !== 'SUCESSO' && item.situacao !== 'CANCELADO'">{{ tentativasItem(item) }}</span>
                  <button type="button" class="cv-button cv-button--primary"
                    *ngIf="item.situacao === 'ERRO' && (permiteVinculacaoLegada ? item.reconciliacao !== 'NAO_NECESSARIA' : publicacao.reconciliacaoMenu) && !exibindoTentativaResolvida"
                    [disabled]="vinculandoExistentes || !canalSelecionado?.ativo" (click)="reconciliePublicacao()">
                    <span class="fa" [class.fa-spinner]="vinculandoExistentes" [class.fa-spin]="vinculandoExistentes"
                      [class.fa-link]="!vinculandoExistentes"></span>
                    {{ vinculandoExistentes ? 'Reconciliando…' : 'Tentar reconciliar' }}
                  </button>
                  <button type="button" class="cv-button cv-button--outline" *ngIf="item.mensagemErro || item.codigoErro"
                    (click)="altereDetalhesTecnicos(item.id)">
                    {{ detalhesTecnicosPublicacao.has(item.id) ? 'Ocultar detalhes' : 'Ver detalhes técnicos' }}
                  </button>
                  <button type="button" class="cv-button cv-button--outline"
                    *ngIf="item.reenvioPermitido && !exibindoTentativaResolvida" (click)="reenvieItem(item.id)">
                    Reenviar produto
                  </button>
                  <small *ngIf="permiteVinculacaoLegada && item.situacao === 'ERRO' && !item.reenvioPermitido && item.reconciliacao !== 'NAO_NECESSARIA'">
                    O reenvio ficará disponível somente após confirmar que o produto não existe no {{ nomePlataforma }}.
                  </small>
                </div>
              </article>
            </div>
            <footer class="cv-reconcile-note">
              <span class="fa fa-info-circle"></span>
              Reconciliar consulta o catálogo e tenta salvar o vínculo. Nenhum produto é reenviado ao {{ nomePlataforma }}.
            </footer>
          </ng-container>
          <ng-template #semPublicacao>
            <div class="cv-empty">
              <span class="fa fa-clock-o"></span>
              <h3>{{ publicacoes.length ? 'Carregando publicação…' : 'Nenhuma publicação enviada' }}</h3>
              <p>{{ publicacoes.length ? 'Aguarde a consulta do resultado.' : 'Crie uma nova publicação a partir do catálogo de produtos.' }}</p>
            </div>
          </ng-template>
        </section>

        <aside class="cv-publication-sidebar">
          <section class="cv-next-steps" *ngIf="publicacao?.quantidadeErros; else situacaoSemErro">
            <h3><span class="fa fa-info-circle"></span> O que fazer agora?</h3>
            <ol>
              <li><span>1</span><div><strong>Tente reconciliar o vínculo</strong><small>O sistema consulta o catálogo para confirmar se o produto já existe.</small></div></li>
              <li><span>2</span><div><strong>Confira o produto no {{ nomePlataforma }}</strong><small>Verifique nome, variação e características antes de reenviar.</small></div></li>
              <li><span>3</span><div><strong>Reenvie somente se ele não existir</strong><small>Isso evita criar produtos duplicados no catálogo.</small></div></li>
            </ol>
          </section>
          <ng-template #situacaoSemErro>
            <section class="cv-next-steps">
              <h3><span class="fa" [class.fa-check-circle]="publicacao?.situacao === 'CONCLUIDA'"
                [class.fa-clock-o]="publicacao?.situacao !== 'CONCLUIDA'"></span>
                {{ publicacao?.situacao === 'CONCLUIDA' ? 'Publicação concluída' : 'Publicação em andamento' }}</h3>
              <p>{{ publicacao?.situacao === 'CONCLUIDA'
                ? 'Todos os itens foram processados com sucesso.'
                : 'Atualize os resultados para acompanhar o retorno do canal.' }}</p>
            </section>
          </ng-template>
          <section class="cv-publication-history">
            <header><h3>Histórico de publicações</h3></header>
            <button type="button" *ngFor="let lote of publicacoes | slice:0:5; trackBy: trackPublicacao" [class.is-active]="lote.id === publicacaoId"
              (click)="abraPublicacao(lote.id)">
              <strong>Publicação #{{ lote.id }} · {{ rotuloSituacaoLote(lote.situacao) }}</strong>
              <small>{{ lote.quantidadeItens }} produto(s) · {{ lote.quantidadeErros - (lote.quantidadeErrosResolvidos || 0) }} requer(em) atenção</small>
              <span class="fa fa-chevron-right"></span>
            </button>
          </section>
        </aside>
      </div>
    </ng-container>

    <div class="cv-history-drawer__scrim" *ngIf="produtoHistorico" (click)="fecheHistorico()"></div>
    <aside class="cv-history-drawer" *ngIf="produtoHistorico" #drawerHistorico tabindex="-1"
      role="dialog" aria-modal="true" aria-labelledby="cv-history-drawer-title"
      [attr.aria-busy]="carregandoHistorico" (keydown)="teclaHistorico($event)">
      <header class="cv-history-drawer__header">
        <div class="cv-history-drawer__product">
          <div class="cv-history-drawer__image">
            <ng-container *ngIf="imagemProdutoHistorico() as imagem">
              <img *ngIf="!imagensComErro.has(imagem)" [src]="imagem" [alt]="produtoHistorico.nome"
                (error)="imagensComErro.add(imagem)">
            </ng-container>
            <span class="fa fa-cube" *ngIf="!imagemProdutoHistorico() || imagensComErro.has(imagemProdutoHistorico())"></span>
          </div>
          <div>
            <span class="cv-kicker">Histórico de publicações</span>
            <h2 id="cv-history-drawer-title">{{ produtoHistorico.nome }}</h2>
            <small>Produto #{{ produtoHistorico.produtoId }} · {{ canalSelecionado?.nome }}</small>
          </div>
        </div>
        <button type="button" class="cv-history-drawer__close" aria-label="Fechar histórico"
          (click)="fecheHistorico()">×</button>
      </header>
      <div class="cv-history-drawer__body">
        <div class="cv-loading" *ngIf="carregandoHistorico">
          <span class="fa fa-spinner fa-spin"></span> Carregando histórico…
        </div>
        <div class="cv-alert cv-alert--error" role="alert" *ngIf="erroHistorico">
          <span>{{ erroHistorico }}</span>
          <button type="button" class="cv-link" (click)="carregueHistorico()">Tentar novamente</button>
        </div>
        <div class="cv-timeline" *ngIf="!carregandoHistorico && historico">
          <article *ngFor="let evento of historico.itens">
            <span class="cv-timeline__dot"></span>
            <div>
              <div class="cv-history-drawer__event-heading">
                <strong>{{ evento.tipoEvento === 'ADICIONAL_COMPARTILHADO' ? 'Adicional compartilhado sincronizado' : rotuloOperacaoItem(evento.operacao) }}</strong>
                <span class="cv-badge" [class.cv-badge--success]="evento.situacao === 'SUCESSO'"
                  [class.cv-badge--warning]="evento.situacao !== 'SUCESSO'">
                  {{ rotuloSituacaoHistorico(evento.situacao) }}
                </span>
              </div>
              <small *ngIf="evento.tipoEvento !== 'ADICIONAL_COMPARTILHADO'">Publicação #{{ evento.publicacaoId }} · {{ evento.tentativas }} tentativa(s)</small>
              <small *ngIf="evento.tipoEvento === 'ADICIONAL_COMPARTILHADO'">Publicação #{{ evento.publicacaoId }} atualizou um adicional usado por este produto</small>
              <time *ngIf="evento.concluidoEm || evento.iniciadoEm || evento.criadoEm">
                {{ (evento.concluidoEm || evento.iniciadoEm || evento.criadoEm) | date:'dd/MM/yyyy HH:mm' }}
              </time>
              <p class="cv-history-drawer__error" *ngIf="evento.mensagemErro">{{ evento.mensagemErro }}</p>
            </div>
          </article>
          <div class="cv-empty" *ngIf="!historico.itens.length">
            <span class="fa fa-history"></span>
            <h3>Nenhuma publicação registrada</h3>
            <p>Este produto ainda não possui histórico neste canal.</p>
          </div>
        </div>
      </div>
    </aside>

    <ng-container *ngIf="aba === 'PENDENTES'">

      <section class="cv-bulk" *ngIf="selecionados.size">
        <div><strong>{{ selecionados.size }}</strong> produto(s) selecionado(s)</div>
        <label>
          <span class="sr-only">Operação em massa</span>
          <select [(ngModel)]="operacaoMassa">
            <option value="">Editar selecionados…</option>
            <option value="DISPONIVEL">Marcar disponível</option>
            <option value="PAUSAR">Pausar vendas</option>
          </select>
        </label>
        <button type="button" class="cv-button cv-button--outline" [disabled]="!operacaoMassa || aplicandoMassa"
          (click)="apliqueOperacaoMassa()">{{ aplicandoMassa ? 'Aplicando…' : 'Aplicar' }}</button>
        <button type="button" class="cv-link" [disabled]="publicando || aplicandoMassa" (click)="limpeSelecao()">Limpar seleção</button>
      </section>

      <div class="cv-workspace">
        <section class="cv-catalog" aria-label="Produtos do catálogo">
          <section class="cv-catalog-heading">
            <div class="cv-section-heading">
              <div>
                <h2>Catálogo de produtos</h2>
                <p>Os produtos continuam aqui depois de publicados.</p>
              </div>
              <button type="button" class="cv-button cv-button--primary" *ngIf="canalSelecionado && permiteVinculacaoExistentes"
                [disabled]="!canalSelecionado.ativo || vinculandoExistentes || publicando || temSalvamento || aplicandoMassa || carregando || desativandoCanal"
                (click)="abraVinculacao()">
                <i class="fa fa-link" aria-hidden="true"></i>
                Vincular produtos existentes no {{ nomePlataforma }}
              </button>
            </div>
            <nav class="cv-catalog-filters" aria-label="Situação no canal">
              <button type="button" class="is-pending" [class.is-active]="filtroCatalogo === 'ALTERACOES'" (click)="filtreCatalogo('ALTERACOES')">Com alteração <span>{{ pagina?.contadores?.alteracoesPendentes || 0 }}</span></button>
              <button type="button" [class.is-active]="filtroCatalogo === 'PUBLICADOS'" (click)="filtreCatalogo('PUBLICADOS')">Publicados <span>{{ pagina?.contadores?.vinculados || 0 }}</span></button>
              <button type="button" [class.is-active]="filtroCatalogo === 'NOVOS'" (click)="filtreCatalogo('NOVOS')">Não publicados <span>{{ pagina?.contadores?.semVinculo || 0 }}</span></button>
              <button type="button" class="is-current" [class.is-active]="filtroCatalogo === 'ATUALIZADOS'" (click)="filtreCatalogo('ATUALIZADOS')">Atualizados <span>{{ pagina?.contadores?.publicados || 0 }}</span></button>
            </nav>
          </section>
          <section class="cv-toolbar">
            <label class="cv-search">
              <span class="fa fa-search" aria-hidden="true"></span>
              <span class="sr-only">Buscar produtos</span>
              <input type="search" maxlength="120" [(ngModel)]="busca" (ngModelChange)="pesquise()"
                placeholder="Buscar produto por nome">
            </label>
            <label class="cv-field cv-field--category">
              <span>Categoria</span>
              <select [(ngModel)]="categoriaId" (ngModelChange)="filtreCatalogo()">
                <option [ngValue]="null">Todas as categorias</option>
                <option *ngFor="let categoria of categoriasCatalogo" [ngValue]="categoria.id">{{ categoria.nome }}</option>
              </select>
            </label>
            <label class="cv-field cv-field--availability">
              <span>Disponibilidade no canal</span>
              <select [(ngModel)]="filtroDisponibilidade" (ngModelChange)="filtreCatalogo()">
                <option value="TODAS">Todas as disponibilidades</option>
                <option value="DISPONIVEIS">Disponíveis</option>
                <option value="PAUSADOS">Pausados</option>
              </select>
            </label>
          </section>
          <div class="cv-catalog__header">
            <label class="cv-check-all">
              <input type="checkbox" [disabled]="publicando || aplicandoMassa || !itensSelecionaveisVisiveis.length"
                [ngModel]="paginaSelecionada" (ngModelChange)="altereSelecaoPagina($event)">
              <span>Selecionar esta página</span>
            </label>
            <span>{{ quantidadeSelecionada }} selecionado(s) · {{ itensVisiveis.length }} de {{ pagina?.total || 0 }} resultado(s)</span>
          </div>

          <div class="cv-loading" *ngIf="carregandoCatalogo"><span class="fa fa-spinner fa-spin"></span> Atualizando catálogo…</div>
          <p class="cv-muted" *ngIf="erroResumos">Não foi possível resumir as alterações. Abra os detalhes ou revise a seleção para tentar novamente.</p>
          <div class="cv-table-heading" aria-hidden="true">
            <span></span><span>Produto</span><span>Categoria</span><span>Cód. PDV</span>
            <span>Preço</span><span>Disponibilidade no {{ nomePlataforma }}</span>
            <span>Situação no canal</span><span>Ações</span>
          </div>
          <div class="cv-empty" *ngIf="!carregandoCatalogo && pagina && !itensVisiveis.length">
            <span class="fa fa-inbox"></span>
            <h3>Nenhum produto encontrado</h3>
            <p>Ajuste a busca ou os filtros. Produtos publicados continuam disponíveis em Todos.</p>
          </div>

          <article class="cv-product" *ngFor="let item of itensVisiveis; trackBy: trackProduto"
            [class.is-selected]="estaSelecionado(item.produtoId)" [class.is-expanded]="expandidos.has(item.produtoId)">
            <div class="cv-product__row">
              <input class="cv-product__check" type="checkbox" [attr.aria-label]="'Selecionar ' + item.nome"
                [disabled]="publicando || aplicandoMassa || !podeSelecionarProduto(item)"
                [ngModel]="estaSelecionado(item.produtoId)"
                (ngModelChange)="altereSelecaoProduto(item.produtoId, $event)">
              <div class="cv-product__image">
                <img *ngIf="item.imagem && !imagensComErro.has(item.imagem)" [src]="item.imagem" [alt]="item.nome"
                  (error)="imagensComErro.add(item.imagem)">
                <span class="fa fa-image" *ngIf="!item.imagem || imagensComErro.has(item.imagem)" aria-hidden="true"></span>
              </div>
              <div class="cv-product__main">
                <div class="cv-product__title-line">
                  <strong>{{ item.nome }}</strong>
                </div>
                <p>{{ item.adicionais.grupos }} grupos · {{ item.adicionais.opcoes }} opções</p>
                <div class="cv-product__shared" *ngFor="let adicional of item.alteracoesCompartilhadas">
                  <span class="fa fa-puzzle-piece" aria-hidden="true"></span>
                  <span><strong>{{ adicional.nome }}</strong><small *ngIf="!adicional.somenteVinculo">{{ descricaoProdutosAfetados(adicional) }}</small></span>
                </div>
                <small *ngIf="item.bloqueio || item.erro">{{ item.bloqueio || item.erro }}</small>
              </div>
              <div class="cv-product__category"><small>Categoria</small>{{ item.categoria?.nome || 'Sem categoria' }}</div>
              <div class="cv-product__pdv"><small>Cód. PDV</small>{{ item.codigoPdv || '—' }}</div>
              <div class="cv-product__prices cv-product__prices--readonly" title="Altere o preço no cadastro do produto">
                <small *ngIf="!precosIguais(item.preco.base, item.preco.final)">
                  Promokit: {{ item.preco.base != null ? (item.preco.base | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}
                </small>
                <strong><ng-container *ngIf="!precosIguais(item.preco.base, item.preco.final)">{{ nomePlataforma }}: </ng-container>{{ item.preco.final != null ? (item.preco.final | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</strong>
                <small *ngIf="precoPublicado(item.produtoId) != null && !precosIguais(precoPublicado(item.produtoId), item.preco.final)">Publicado: {{ precoPublicado(item.produtoId) | currency:'BRL':'symbol':'1.2-2':'pt' }}</small>
              </div>
              <div class="cv-product__state">
                <label class="cv-sale-toggle">
                  <input type="checkbox" [ngModel]="edicoes[item.produtoId]?.disponivel"
                    [disabled]="!canalSelecionado?.ativo || publicando || aplicandoMassa || edicoes[item.produtoId]?.salvando || item.situacaoPublicacao === 'PUBLICANDO'"
                    (ngModelChange)="altereDisponibilidade(item, $event)" [attr.aria-label]="'Disponibilidade de ' + item.nome + ' no canal'">
                  <span>{{ item.vinculo === 'SEM_VINCULO' ? (edicoes[item.produtoId]?.disponivel ? 'Disponível ao publicar' : 'Pausado ao publicar') : (edicoes[item.produtoId]?.disponivel ? 'Disponível' : 'Pausado') }}</span>
                </label>
                <small *ngIf="edicoes[item.produtoId]?.salvando"><span class="fa fa-spinner fa-spin"></span> Salvando…</small>

              </div>
              <div class="cv-product__publication">
                <span class="cv-badge" [class.cv-badge--success]="item.situacaoPublicacao === 'PUBLICADO'"
                  [class.cv-badge--error]="!!item.bloqueio || item.situacaoPublicacao === 'ERRO' || item.situacaoPublicacao === 'BLOQUEADO' || temErroCompartilhado(item)"
                  [class.cv-badge--warning]="item.vinculo === 'VINCULADO' && !temErroCompartilhado(item) && (item.situacaoPublicacao === 'PENDENTE' || !!item.alteracoesCompartilhadas?.length)"
                  [class.cv-badge--neutral]="item.vinculo === 'SEM_VINCULO'">
                  {{ rotuloProduto(item) }}
                </span>
                <small>{{ (item.vinculo === 'VINCULADO' ? 'Publicado no ' : 'Sem vínculo com o ') + nomePlataforma }}</small>
                <span class="cv-change-chip" *ngFor="let etiqueta of etiquetasAlteracoes(item.produtoId)">{{ etiqueta }}</span>
                <ng-container *ngFor="let adicional of item.alteracoesCompartilhadas">
                  <span class="cv-change-chip" *ngFor="let resumo of adicional.resumoAlteracoes">{{ resumo }}</span>
                  <span class="cv-change-chip" *ngIf="!adicional.resumoAlteracoes?.length">Alteração em {{ adicional.nome }}</span>
                  <small class="cv-shared-error" *ngIf="adicional.situacao === 'ERRO'">{{ adicional.ultimoErro || 'Falha no último envio do adicional' }}</small>
                </ng-container>
                <small *ngIf="item.situacaoPublicacao === 'PUBLICADO' && !item.alteracoesCompartilhadas?.length">Sem alterações pendentes</small>
              </div>
              <div class="cv-product__actions">
                <button type="button" class="cv-link" [attr.aria-expanded]="expandidos.has(item.produtoId)" (click)="expandaProduto(item)">
                  {{ expandidos.has(item.produtoId) ? 'Ocultar detalhes' : (item.vinculo === 'SEM_VINCULO' ? 'Configurar' : 'Revisar') }}
                </button>
                <button type="button" class="cv-link" (click)="abraHistorico(item)">Histórico</button>
                <button type="button" class="cv-link" *ngIf="item.ultimoEnvio" (click)="abraUltimoEnvio(item)"
                  [attr.aria-label]="'Ver último envio de ' + item.nome">
                  <time>{{ item.ultimoEnvio.criadoEm | date:'dd/MM HH:mm' }}</time>
                  <small [class.is-success]="item.ultimoEnvio.situacao === 'SUCESSO'" [class.is-error]="item.ultimoEnvio.situacao === 'ERRO'">
                    {{ item.ultimoEnvio.situacao === 'PENDENTE' ? 'Aguardando processamento' : rotuloSituacaoProduto(item.ultimoEnvio.situacao) }}
                  </small>
                </button>
              </div>
            </div>

            <div class="cv-product__details" *ngIf="expandidos.has(item.produtoId)">
              <div class="cv-loading" *ngIf="carregandoPrevia.has(item.produtoId)">
                <span class="fa fa-spinner fa-spin"></span> Gerando prévia atualizada…
              </div>
              <ng-container *ngIf="previas[item.produtoId] as previa">
                <section class="cv-shared-details" *ngIf="item.alteracoesCompartilhadas?.length">
                  <div class="cv-section-heading cv-section-heading--small">
                    <div><span class="cv-kicker">Adicionais compartilhados</span><h3>Alterações incluídas neste envio</h3></div>
                  </div>
                  <article *ngFor="let adicional of item.alteracoesCompartilhadas">
                    <header>
                      <div><strong>{{ adicional.nome }}</strong><small>{{ descricaoProdutosAfetados(adicional) }}</small></div>
                      <span>{{ adicional.quantidadeOpcoes }} opção(ões)</span>
                    </header>
                    <p class="cv-error-text" *ngIf="adicional.situacao === 'ERRO'">Falha anterior: {{ adicional.ultimoErro }}</p>
                    <div class="cv-shared-details__change" *ngFor="let alteracao of adicional.alteracoesDetalhadas">
                      <strong>{{ alteracao.rotulo }}</strong>
                      <span>{{ valorAlteracaoCompartilhada(alteracao.antes, alteracao.campo) }}</span>
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                      <b>{{ valorAlteracaoCompartilhada(alteracao.depois, alteracao.campo) }}</b>
                    </div>
                    <small class="cv-shared-details__products">
                      Afeta: <span *ngFor="let produto of adicional.produtosAfetados; let ultimo = last">{{ produto.nome }}{{ ultimo ? '' : ', ' }}</span>
                    </small>
                  </article>
                </section>
                <div class="cv-changes" *ngIf="item.vinculo === 'VINCULADO'">
                  <div class="cv-section-heading cv-section-heading--small">
                    <div>
                      <span class="cv-kicker">O que será atualizado</span>
                      <h3>{{ quantidadeAlteracoes(previa) }} alteração(ões)</h3>
                    </div>
                    <span class="cv-badge" [class.cv-badge--success]="previa.publicavel"
                      [class.cv-badge--warning]="!previa.publicavel">
                      {{ previa.publicavel ? 'Pronto para publicar' : (previa.operacao === 'NENHUMA' ? 'Sem alterações' : 'Requer atenção') }}
                    </span>
                  </div>
                  <div class="cv-compare">
                    <section>
                      <span class="cv-column-label">Publicado no {{ nomePlataforma }} · última versão registrada</span>
                      <div class="cv-compare-product">
                        <ng-container *ngIf="imagemSnapshot(previa.publicado) as imagemPublicada; else semImagemPublicada">
                          <img *ngIf="!imagensComErro.has(imagemPublicada); else semImagemPublicada"
                            [src]="imagemPublicada" alt="Imagem publicada" (error)="imagensComErro.add(imagemPublicada)">
                        </ng-container>
                        <ng-template #semImagemPublicada><span class="fa fa-image" aria-hidden="true"></span></ng-template>
                        <div><strong>{{ previa.publicado?.conteudo?.nome || 'Sem versão publicada registrada' }}</strong>
                          <p>{{ previa.publicado?.conteudo?.descricao || '—' }}</p>
                          <b>{{ previa.publicado?.comercial?.preco == null ? '—' : (previa.publicado?.comercial?.preco | currency:'BRL':'symbol':'1.2-2':'pt') }}</b>
                          <p *ngFor="let grupo of previa.publicado?.estrutura?.gruposAdicionais">
                            <strong>{{ grupo.nome }}</strong> · mín. {{ grupo.minimo }} / máx. {{ grupo.maximo }}
                            <small *ngFor="let opcao of grupo.opcoes">{{ opcao.nome }} · {{ opcao.preco | currency:'BRL':'symbol':'1.2-2':'pt' }} · {{ opcao.disponivel ? 'Ativa' : 'Pausada' }}<br></small>
                          </p>
                        </div>
                      </div>
                    </section>
                    <span class="fa fa-long-arrow-right cv-compare__arrow" aria-hidden="true"></span>
                    <section>
                      <span class="cv-column-label">Próximo envio</span>
                      <div class="cv-compare-product">
                        <ng-container *ngIf="imagemSnapshot(previa.desejado) as proximaImagem; else semProximaImagem">
                          <img *ngIf="!imagensComErro.has(proximaImagem); else semProximaImagem"
                            [src]="proximaImagem" alt="Nova imagem" (error)="imagensComErro.add(proximaImagem)">
                        </ng-container>
                        <ng-template #semProximaImagem><span class="fa fa-image" aria-hidden="true"></span></ng-template>
                        <div><strong>{{ previa.desejado?.conteudo?.nome || item.nome }}</strong>
                          <p>{{ previa.desejado?.conteudo?.descricao || '—' }}</p>
                          <b>{{ previa.desejado?.comercial?.preco == null ? '—' : (previa.desejado?.comercial?.preco | currency:'BRL':'symbol':'1.2-2':'pt') }}</b>
                          <p *ngFor="let grupo of previa.desejado?.estrutura?.gruposAdicionais">
                            <strong>{{ grupo.nome }}</strong> · mín. {{ grupo.minimo }} / máx. {{ grupo.maximo }}
                            <small *ngFor="let opcao of grupo.opcoes">{{ opcao.nome }} · {{ opcao.preco | currency:'BRL':'symbol':'1.2-2':'pt' }} · {{ opcao.disponivel ? 'Ativa' : 'Pausada' }}<br></small>
                          </p>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="cv-difference-list">
                    <article *ngFor="let diferenca of diferencasVisiveis(previa)">
                      <span class="cv-difference-list__icon fa fa-exchange"></span>
                      <div><strong>{{ rotuloDiferenca(diferenca.caminho) }}</strong><small>{{ diferenca.tipo }}</small></div>
                      <span>{{ valorDiferenca(diferenca.antes) }}</span>
                      <i class="fa fa-long-arrow-right"></i>
                      <b>{{ valorDiferenca(diferenca.depois) }}</b>
                    </article>
                  </div>
                  <div class="cv-inline-actions">
                    <button type="button" class="cv-link cv-link--with-icon" (click)="corrijaProduto(item.produtoId)">
                      <span class="fa fa-pencil"></span> Editar produto
                    </button>
                    <button type="button" class="cv-link cv-link--with-icon" (click)="abraHistorico(item)">
                      <span class="fa fa-history"></span> Histórico
                    </button>
                  </div>
                </div>

                <div class="cv-detail-grid">
                  <section class="cv-snapshot-card">
                    <div class="cv-section-heading cv-section-heading--small">
                      <div><span class="cv-kicker">Vai junto com o produto</span><h3>Grupos e opções</h3></div>
                      <span>{{ previa.desejado?.estrutura?.gruposAdicionais?.length || 0 }} grupo(s)</span>
                    </div>
                    <p class="cv-muted">Adicionais são lidos do cadastro do produto e revisados aqui. A edição é feita cadastro produtosqual d</p>
                    <div class="cv-addition" *ngFor="let grupo of previa.desejado?.estrutura?.gruposAdicionais; trackBy: trackGrupo">
                      <div class="cv-addition__head">
                        <div><strong>{{ grupo.nome }}</strong><small>Mín. {{ grupo.minimo }} · Máx. {{ grupo.maximo }}</small></div>
                        <span class="cv-badge" [class.cv-badge--warning]="!grupo.disponivel">{{ grupo.disponivel ? 'Ativo' : 'Pausado' }}</span>
                      </div>
                      <div class="cv-option" *ngFor="let opcao of grupo.opcoes">
                        <span>{{ opcao.nome }}</span>
                        <strong>{{ opcao.preco | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong>
                        <small>{{ opcao.disponivel ? 'Ativa' : 'Pausada' }}</small>
                      </div>
                    </div>
                    <div class="cv-empty cv-empty--small" *ngIf="!previa.desejado?.estrutura?.gruposAdicionais?.length">
                      Nenhum grupo representável na prévia atual.
                    </div>
                    <button type="button" class="cv-link cv-link--with-icon" (click)="corrijaProduto(item.produtoId)">
                      <span class="fa fa-pencil"></span> Editar cadastro e adicionais
                    </button>
                  </section>
                </div>

                <div class="cv-blockers" *ngIf="bloqueiosCadastro(previa).length">
                  <h4><span class="fa fa-ban"></span> Este produto não pode ser publicado agora</h4>
                  <article *ngFor="let bloqueio of bloqueiosCadastro(previa)">
                    <strong>{{ bloqueio.campo }}</strong>
                    <span>{{ bloqueio.mensagem }}</span>
                    <small>{{ bloqueio.orientacao }}</small>
                  </article>
                  <p>Pizza, combo, peso e tamanhos permanecem fora do MVP quando identificados pelo servidor.</p>
                  <button type="button" class="cv-button cv-button--outline" (click)="corrijaProduto(item.produtoId)">Corrigir no cadastro</button>
                </div>
              </ng-container>
            </div>
          </article>

          <nav class="cv-pagination" *ngIf="pagina && totalPaginas > 1" aria-label="Paginação do catálogo">
            <button type="button" [disabled]="numeroPagina <= 1" (click)="mudePagina(numeroPagina - 1)">Anterior</button>
            <span>Página {{ numeroPagina }} de {{ totalPaginas }}</span>
            <button type="button" [disabled]="numeroPagina >= totalPaginas" (click)="mudePagina(numeroPagina + 1)">Próxima</button>
          </nav>
        </section>

        <aside class="cv-summary" aria-label="Resumo da publicação">
          <div class="cv-summary__head">
            <span class="cv-kicker">Próximo envio</span>
            <h2>{{ quantidadeSelecionada }} item(ns) selecionado(s)</h2>
            <p>A seleção é mantida ao trocar de página.</p>
          </div>
          <dl *ngIf="!previaLote">
            <div><dt>Novos produtos<small>Criar e vincular no {{ nomePlataforma }}</small></dt><dd>{{ resumoSelecao.novos }}</dd></div>
            <div><dt>Atualizações<small>Produtos já publicados</small></dt><dd>{{ resumoSelecao.atualizacoes }}</dd></div>
            <div *ngIf="resumoSelecao.semAlteracoes"><dt>Sem alterações<small>Não serão reenviados sem mudanças</small></dt><dd>{{ resumoSelecao.semAlteracoes }}</dd></div>
          </dl>
          <dl *ngIf="previaLote">
            <div><dt>Publicáveis</dt><dd class="is-success">{{ previaLote.publicaveis }}</dd></div>
            <div><dt>Bloqueados</dt><dd class="is-error">{{ previaLote.bloqueados }}</dd></div>
            <div><dt>Criações</dt><dd>{{ previaLote.resumo.criar }}</dd></div>
            <div><dt>Atualizações</dt><dd>{{ previaLote.resumo.atualizar }}</dd></div>
            <div><dt>Preços</dt><dd>{{ previaLote.resumo.preco }}</dd></div>
            <div><dt>Status</dt><dd>{{ previaLote.resumo.status }}</dd></div>
            <div><dt>Grupos</dt><dd>{{ previaLote.resumo.grupos }}</dd></div>
            <div><dt>Opções</dt><dd>{{ previaLote.resumo.opcoes }}</dd></div>
          </dl>
          <div class="cv-summary__notice">
            <span class="fa fa-info-circle"></span>
            <p>Salvar não publica automaticamente. Revise antes de enviar ao {{ nomePlataforma }}.</p>
          </div>
          <div class="cv-summary-changes" *ngIf="etiquetasSelecionadas.length">
            <strong>Alterações selecionadas</strong>
            <span class="cv-change-chip" *ngFor="let etiqueta of etiquetasSelecionadas">{{ etiqueta }}</span>
          </div>
          <button type="button" class="cv-button cv-button--publish" [disabled]="!quantidadeSelecionada || publicando || temSalvamento || aplicandoMassa || !canalSelecionado?.ativo"
            (click)="revisePublicacao()">
            <span class="fa" [ngClass]="publicando ? 'fa-spinner fa-spin' : 'fa-eye'"></span> {{ publicando ? 'Preparando revisão…' : ('Revisar ' + quantidadeSelecionada + ' itens') }}
          </button>
          <button type="button" class="cv-button cv-button--outline" *ngIf="recursosCancelaveisSelecionados.length"
            [disabled]="!canalSelecionado?.ativo || publicando || descartandoPendencias || temSalvamento || aplicandoMassa"
            (click)="abraDescartePendencias()">
            Cancelar {{ recursosCancelaveisSelecionados.length }} pendência(s) de adicionais
          </button>
          <p class="cv-muted">A confirmação do envio acontece na revisão.</p>
          <small *ngIf="quantidadeSelecionada > 100">Selecione até 100 produtos para uma prévia explícita.</small>
        </aside>
      </div>
    </ng-container>
  </ng-container>

  <section class="cv-empty cv-empty--page" *ngIf="!carregando && !canalSelecionadoId">
    <span class="fa fa-plug"></span>
    <h2>Configure um canal de venda</h2>
    <p>Use uma integração já autorizada para escolher o merchant e o catálogo externo.</p>
    <button type="button" class="cv-button cv-button--primary" [disabled]="salvandoCanal" (click)="abraNovoCanal()">Criar canal</button>
  </section>

  <div class="cv-modal-backdrop" *ngIf="revisaoAberta && previaLote" (click)="revisaoAberta = false"></div>
  <section class="cv-modal cv-modal--review" [class.cv-modal--review-detail]="detalhesRevisao.size > 0"
    role="dialog" aria-modal="true" aria-labelledby="cv-review-title"
    *ngIf="revisaoAberta && previaLote">
    <header>
      <div class="cv-review-heading">
        <img *ngIf="canalSelecionado?.plataforma !== 'FOOD99'" src="assets/icons/logo-ifood.png" alt="iFood">
        <div><span class="cv-kicker" *ngIf="!detalhesRevisao.size">Confirmação</span>
          <h2 id="cv-review-title">{{ detalhesRevisao.size ? 'Revisão de publicação' : 'Revisar publicação no ' + nomePlataforma }}</h2>
          <p *ngIf="!detalhesRevisao.size">Confira os produtos que serão enviados ou atualizados no seu catálogo do {{ nomePlataforma }}.<br>Compare com a última versão registrada e verifique se tudo está correto.</p>
        </div>
      </div>
      <button type="button" aria-label="Fechar revisão" (click)="revisaoAberta = false">×</button>
    </header>
    <div class="cv-modal__body">
      <div class="cv-review-counters">
        <article><i class="fa fa-list-ul" aria-hidden="true"></i><div><strong>{{ previaLote.publicaveis }}</strong><span>Produtos para publicar</span></div></article>
        <article class="is-success"><i class="fa fa-plus" aria-hidden="true"></i><div><strong>{{ novosNaRevisao }}</strong><span>Novos produtos</span></div></article>
        <article class="is-changed"><i class="fa fa-pencil" aria-hidden="true"></i><div><strong>{{ alteradosNaRevisao }}</strong><span>Com alterações</span></div></article>
        <article class="is-info" [class.is-error]="previaLote.bloqueados > 0"><i class="fa fa-info-circle" aria-hidden="true"></i><div><strong>{{ previaLote.bloqueados }}</strong><span>Pendências</span></div></article>
      </div>

      <p class="cv-review-info"><i class="fa fa-info-circle" aria-hidden="true"></i> Essa não é uma consulta em tempo real ao {{ nomePlataforma }}. Os dados são baseados na última sincronização registrada.</p>
      <div class="cv-alert cv-alert--warning" *ngIf="revisaoDesatualizada" role="status">
        <span>Um produto mudou desde esta revisão. Revise novamente antes de publicar.</span>
        <button type="button" class="cv-button cv-button--outline" [disabled]="publicando" (click)="revisePublicacao()">Revisar novamente</button>
      </div>
      <section class="cv-review-prices" *ngIf="previaLote.precosAConfirmar?.length">
        <div class="cv-review-prices__heading">
          <div>
            <span class="cv-kicker">Preços novos ou alterados</span>
            <h3>Revise os valores antes de publicar</h3>
            <p>Ajuste os preços abaixo. Ao confirmar, eles serão salvos na tabela deste canal; a publicação ocorre somente no botão Publicar.</p>
          </div>
          <span class="cv-badge" [class.cv-badge--success]="precosDaRevisaoConfirmados">
            {{ precosDaRevisaoConfirmados ? 'Preços confirmados' : 'Confirmação pendente' }}
          </span>
        </div>
        <div class="cv-review-prices__table">
          <div class="cv-review-prices__columns" aria-hidden="true">
            <span>Item</span><span>Origem atual</span><span>Preço sugerido</span><span>Preço no canal</span><span>Status</span>
          </div>
          <ng-container *ngFor="let produto of previaLote.itens">
            <div class="cv-review-prices__product" *ngIf="precosRevisaoPorProduto[produto.produtoId]?.length">
              <div class="cv-review-price cv-review-price--product" *ngIf="precosRevisaoPorProduto[produto.produtoId][0].tipo !== 'PRODUTO'">
                <div class="cv-review-price__identity">
                  <button type="button" class="cv-review-price__toggle" [attr.aria-expanded]="!precosRevisaoRecolhidos.has(produto.produtoId)"
                    [attr.aria-label]="(precosRevisaoRecolhidos.has(produto.produtoId) ? 'Mostrar' : 'Ocultar') + ' adicionais de ' + nomeProdutoRevisao(produto)"
                    (click)="alterneAdicionaisRevisao(produto.produtoId)">
                    <i class="fa" [class.fa-chevron-down]="!precosRevisaoRecolhidos.has(produto.produtoId)" [class.fa-chevron-right]="precosRevisaoRecolhidos.has(produto.produtoId)" aria-hidden="true"></i>
                  </button>
                  <i class="fa fa-cube" aria-hidden="true"></i><strong>{{ nomeProdutoRevisao(produto) }}</strong>
                </div>
              </div>
              <ng-container *ngFor="let preco of precosRevisaoPorProduto[produto.produtoId]">
                <div class="cv-review-price" *ngIf="preco.tipo === 'PRODUTO' || !precosRevisaoRecolhidos.has(produto.produtoId)"
                  [class.cv-review-price--product]="preco.tipo === 'PRODUTO'"
                  [class.cv-review-price--option]="preco.tipo === 'OPCAO_ADICIONAL'">
                  <div class="cv-review-price__identity">
                    <button type="button" class="cv-review-price__toggle" *ngIf="preco.tipo === 'PRODUTO' && precosRevisaoPorProduto[produto.produtoId].length > 1"
                      [attr.aria-expanded]="!precosRevisaoRecolhidos.has(produto.produtoId)"
                      [attr.aria-label]="(precosRevisaoRecolhidos.has(produto.produtoId) ? 'Mostrar' : 'Ocultar') + ' adicionais de ' + nomeProdutoRevisao(produto)"
                      (click)="alterneAdicionaisRevisao(produto.produtoId)">
                      <i class="fa" [class.fa-chevron-down]="!precosRevisaoRecolhidos.has(produto.produtoId)" [class.fa-chevron-right]="precosRevisaoRecolhidos.has(produto.produtoId)" aria-hidden="true"></i>
                    </button>
                    <i class="fa" [class.fa-cube]="preco.tipo === 'PRODUTO'" [class.fa-tag]="preco.tipo === 'OPCAO_ADICIONAL'" aria-hidden="true"></i>
                    <div><strong>{{ preco.tipo === 'PRODUTO' ? nomeProdutoRevisao(produto) : preco.nome }}</strong>
                      <small *ngIf="preco.tipo === 'OPCAO_ADICIONAL'">{{ preco.grupoNome || 'Adicional' }}<ng-container *ngIf="preco.produtoIds.length > 1"> · compartilhado com {{ preco.produtoIds.length }} produtos desta revisão</ng-container></small></div>
                  </div>
                  <span class="cv-review-price__origin">{{ rotuloOrigemPrecoRevisao(preco) }}</span>
                  <strong class="cv-review-price__suggested" [class.cv-review-price__suggested--empty]="preco.precoFinal == null">
                    {{ preco.precoFinal == null ? 'Definir manualmente' : (preco.precoFinal | currency:'BRL':'symbol':'1.2-2':'pt') }}
                  </strong>
                  <label class="cv-review-price__edit" [attr.for]="'cv-preco-' + preco.tipo + '-' + preco.alvoId + '-' + produto.produtoId">
                    <span><span class="cv-review-price__currency">R$</span><input type="number" min="0" max="99999999.99" step="0.01" inputmode="decimal"
                      [id]="'cv-preco-' + preco.tipo + '-' + preco.alvoId + '-' + produto.produtoId"
                      [attr.aria-label]="'Preço no canal para ' + (preco.tipo === 'PRODUTO' ? nomeProdutoRevisao(produto) : preco.nome)"
                      [ngModel]="precosRevisao[chavePrecoRevisao(preco)]"
                      (ngModelChange)="alterePrecoRevisao(preco, $event)"
                      [disabled]="salvandoPrecosRevisao || publicando || revisaoDesatualizada"></span>
                    <small *ngIf="preco.descontoCanal">Desconto atual de {{ preco.descontoCanal | currency:'BRL':'symbol':'1.2-2':'pt' }} será mantido</small>
                  </label>
                  <span class="cv-review-price__status" [class.cv-review-price__status--saved]="precosDaRevisaoConfirmados">
                    <i class="fa" [class.fa-check-circle]="precosDaRevisaoConfirmados" [class.fa-clock-o]="!precosDaRevisaoConfirmados" aria-hidden="true"></i>
                    {{ precosDaRevisaoConfirmados ? 'Confirmado' : 'Pendente' }}
                  </span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <p class="cv-review-prices__error" *ngIf="!precosRevisaoValidos">Informe todos os preços em reais, sem valor negativo e com até duas casas decimais.</p>
        <button type="button" class="cv-button cv-button--primary cv-review-prices__confirm"
          [disabled]="publicando || salvandoPrecosRevisao || revisaoDesatualizada || !precosRevisaoValidos || precosDaRevisaoConfirmados"
          (click)="confirmePrecosRevisao()">
          <i class="fa" [class.fa-check]="!salvandoPrecosRevisao" [class.fa-spinner]="salvandoPrecosRevisao" [class.fa-spin]="salvandoPrecosRevisao" aria-hidden="true"></i>
          {{ salvandoPrecosRevisao ? 'Salvando preços…' : precosDaRevisaoConfirmados ? 'Preços salvos' : ('Salvar e confirmar ' + previaLote.precosAConfirmar.length + ' preços') }}
        </button>
      </section>
      <article class="cv-review-item" *ngFor="let item of previaLote.itens" [class.cv-review-item--expanded]="detalhesRevisao.has(item.produtoId)">
        <div class="cv-review-product">
          <div class="cv-review-thumbnail">
            <ng-container *ngIf="imagemProdutoRevisao(item) as imagem; else semMiniaturaRevisao">
              <img [src]="imagem" [alt]="nomeProdutoRevisao(item)" (error)="imagensComErro.add(imagem)">
            </ng-container>
            <ng-template #semMiniaturaRevisao><i class="fa fa-image" aria-hidden="true"></i></ng-template>
          </div>
          <div>
            <strong>{{ nomeProdutoRevisao(item) }}</strong>
            <span class="cv-review-product__id">#{{ item.produtoId }} · Categoria: {{ produtoDaPrevia(item.produtoId)?.categoria?.nome || 'Sem categoria' }}</span>
            <div class="cv-review-operation"><span>{{ rotuloOperacaoRevisao(item) }}</span>
              <div class="cv-review-areas"><span *ngIf="item.operacao === 'CRIAR'" class="is-new">Novo</span><span *ngFor="let area of areasAlteradasRevisao(item)">{{ area }}</span></div>
            </div>
            <div class="cv-review-shared" *ngFor="let adicional of produtoDaPrevia(item.produtoId)?.alteracoesCompartilhadas">
              <strong><i class="fa fa-puzzle-piece" aria-hidden="true"></i> {{ adicional.nome }}</strong>
              <small>{{ descricaoProdutosAfetados(adicional) }}</small>
              <span *ngFor="let resumo of adicional.resumoAlteracoes">{{ resumo }}</span>
            </div>
          </div>
        </div>
        <span class="cv-badge" [class.cv-badge--success]="item.publicavel" [class.cv-badge--warning]="!item.publicavel && item.operacao !== 'NENHUMA'">
          {{ item.publicavel ? 'Publicável' : (item.operacao === 'NENHUMA' ? 'Sem alterações · não será enviado' : (categoriaPendente(item) ? 'Categoria pendente' : (item.situacao === 'PUBLICANDO' ? 'Em processamento' : 'Bloqueado'))) }}
        </span>
        <small *ngIf="item.bloqueios[0] && !categoriaPendente(item)">{{ item.bloqueios[0].mensagem }}</small>
        <button type="button" class="cv-link cv-review-expand" [attr.aria-expanded]="detalhesRevisao.has(item.produtoId)"
          [attr.aria-controls]="'cv-review-details-' + item.produtoId" [disabled]="publicando"
          [attr.aria-label]="(detalhesRevisao.has(item.produtoId) ? 'Ocultar detalhes de ' : 'Ver detalhes de ') + nomeProdutoRevisao(item)"
          (click)="alterneDetalhesRevisao(item)">
          <i class="fa" [class.fa-chevron-up]="detalhesRevisao.has(item.produtoId)" [class.fa-chevron-down]="!detalhesRevisao.has(item.produtoId)" aria-hidden="true"></i>
        </button>
        <section class="cv-review-details" *ngIf="detalhesRevisao.has(item.produtoId)" [id]="'cv-review-details-' + item.produtoId">
          <p *ngIf="carregandoDetalhesRevisao.has(item.produtoId)" role="status"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Carregando comparação…</p>
          <div *ngIf="errosDetalhesRevisao[item.produtoId]" class="cv-alert cv-alert--warning" role="status">
            <span>{{ errosDetalhesRevisao[item.produtoId] }}</span>
            <button type="button" class="cv-link" (click)="carregueDetalhesRevisao(item)" [disabled]="publicando || revisaoDesatualizada">Tentar novamente</button>
          </div>
          <ng-container *ngIf="comparacoesRevisao[item.produtoId] as comparacao">
            <nav class="cv-review-tabs" aria-label="Detalhes da revisão">
              <button type="button" [class.is-active]="!abasRevisao[item.produtoId] || abasRevisao[item.produtoId] === 'PRODUTO'" (click)="abasRevisao[item.produtoId] = 'PRODUTO'">Detalhes do produto</button>
              <button type="button" [class.is-active]="abasRevisao[item.produtoId] === 'IMAGEM'" (click)="abasRevisao[item.produtoId] = 'IMAGEM'">Imagem ({{ item.desejado?.conteudo?.imagem?.url ? 1 : 0 }})</button>
              <button type="button" [class.is-active]="abasRevisao[item.produtoId] === 'ADICIONAIS'" (click)="abasRevisao[item.produtoId] = 'ADICIONAIS'">Grupos e opções ({{ comparacao.grupos.length }})</button>
            </nav>
            <section class="cv-review-groups" *ngIf="abasRevisao[item.produtoId] === 'ADICIONAIS'">
              <div class="cv-review-groups__note">
                <div><i class="fa fa-info-circle" aria-hidden="true"></i><span>
                  <strong *ngIf="item.operacao === 'CRIAR'">Novo produto: confira os grupos e opções que serão criados ou reutilizados no {{ nomePlataforma }}.</strong>
                  <strong *ngIf="item.operacao !== 'CRIAR'">Confira o que muda nos grupos e opções deste produto.</strong>
                  <small>A comparação usa a última versão registrada, não uma consulta em tempo real ao {{ nomePlataforma }}.</small>
                </span></div>
                <div class="cv-review-groups__legend" aria-label="Legenda da comparação">
                  <span><i class="is-new"></i>Novo</span><span><i class="is-unchanged"></i>Sem alterações / já vinculado</span>
                  <span><i class="is-updated"></i>Será atualizado</span>
                </div>
              </div>
              <p class="cv-muted" *ngIf="!comparacao.grupos.length">Nenhum grupo ou opção para exibir.</p>
              <article class="cv-review-group" *ngFor="let grupo of comparacao.grupos; let indice = index">
                <div class="cv-review-group__heading">
                  <span class="cv-review-group__number">{{ indice + 1 }}</span>
                  <div class="cv-review-group__identity">
                    <div class="cv-review-group__badges"><strong>{{ grupo.nome }}</strong>
                      <span [class.is-required]="grupo.obrigatorio">{{ grupo.obrigatorio ? 'Obrigatório' : 'Opcional' }}</span>
                      <span>Mínimo {{ grupo.minimo }}</span><span>Máximo {{ grupo.maximo }}</span>
                      <span [class.is-active]="grupo.disponivel">{{ grupo.disponivel ? 'Ativo' : 'Pausado' }}</span>
                      <span>Ordem {{ grupo.ordem }}</span><span class="is-removed" *ngIf="grupo.removido">Removido</span>
                    </div>
                  </div>
                  <span class="cv-review-group__count">{{ grupo.opcoes.length }} {{ grupo.opcoes.length === 1 ? 'opção' : 'opções' }}</span>
                  <button type="button" class="cv-review-group__toggle"
                    [attr.aria-expanded]="!gruposRevisaoRecolhidos.has(item.produtoId + ':' + grupo.chave)"
                    [attr.aria-controls]="'cv-review-group-' + item.produtoId + '-' + indice"
                    [attr.aria-label]="(gruposRevisaoRecolhidos.has(item.produtoId + ':' + grupo.chave) ? 'Mostrar' : 'Ocultar') + ' opções de ' + grupo.nome"
                    (click)="alterneGrupoRevisao(item.produtoId, grupo.chave)">
                    <i class="fa" [class.fa-chevron-up]="!gruposRevisaoRecolhidos.has(item.produtoId + ':' + grupo.chave)"
                      [class.fa-chevron-down]="gruposRevisaoRecolhidos.has(item.produtoId + ':' + grupo.chave)" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="cv-review-group__table" *ngIf="!gruposRevisaoRecolhidos.has(item.produtoId + ':' + grupo.chave)"
                  [id]="'cv-review-group-' + item.produtoId + '-' + indice">
                  <div class="cv-review-group__columns"><span>Campo (opção)</span><span>Atual (sistema)</span>
                    <span>Última versão {{ nomePlataforma }}</span><span>Próximo envio</span></div>
                  <div class="cv-review-group__row" *ngFor="let opcao of grupo.opcoes">
                    <span class="cv-review-group__option"><i class="fa fa-tag" aria-hidden="true"></i><strong>{{ opcao.nome }}</strong></span>
                    <span class="cv-review-group__value"><small>Atual (sistema)</small>{{ opcao.atual == null ? '—' : (opcao.atual | currency:'BRL':'symbol':'1.2-2':'pt') }}</span>
                    <span class="cv-review-group__value"><small>Última versão {{ nomePlataforma }}</small>{{ opcao.anterior == null ? '—' : (opcao.anterior | currency:'BRL':'symbol':'1.2-2':'pt') }}</span>
                    <div class="cv-review-group__status"><small>Próximo envio</small>
                      <span class="cv-review-result" [class.is-new]="opcao.acao === 'Novo'"
                        [class.is-changed]="opcao.acao === 'Será atualizado'" [class.is-removed]="opcao.acao === 'Removido'">{{ opcao.acao }}</span>
                    </div>
                  </div>
                  <p class="cv-muted" *ngIf="!grupo.opcoes.length">Este grupo não possui opções.</p>
                </div>
              </article>
            </section>
            <p class="cv-muted" *ngIf="item.operacao === 'CRIAR' && abasRevisao[item.produtoId] !== 'ADICIONAIS'">Novo produto: este conteúdo será criado no {{ nomePlataforma }}, junto com os grupos e opções abaixo.</p>
            <p class="cv-muted" *ngIf="item.operacao !== 'CRIAR' && !item.publicado && abasRevisao[item.produtoId] !== 'ADICIONAIS'">Sem versão publicada registrada para comparação completa.</p>
            <p class="cv-muted" *ngIf="item.operacao === 'NENHUMA'">Este produto não tem alterações e não será incluído no envio.</p>
            <p class="cv-muted" *ngIf="abasRevisao[item.produtoId] !== 'ADICIONAIS' && !linhasDaAbaRevisao(item.produtoId).length">Nenhum dado para exibir nesta aba.</p>
            <div class="cv-review-comparison" *ngIf="abasRevisao[item.produtoId] !== 'ADICIONAIS' && linhasDaAbaRevisao(item.produtoId).length">
              <div class="cv-review-comparison__heading"><span>Campo</span><span>Atual (sistema)</span><span>Última versão {{ nomePlataforma }}</span><span>Próximo envio</span></div>
              <div class="cv-review-change" *ngFor="let linha of linhasDaAbaRevisao(item.produtoId)"
                [class.cv-review-change--changed]="linha.alterada">
                <div class="cv-review-change__field"><strong>{{ linha.campo }}</strong></div>
                <div class="cv-review-change__value" *ngFor="let valor of [linha.depois, linha.antes]; let lado = index">
                  <span class="cv-review-change__label">{{ lado === 0 ? 'Atual (sistema)' : 'Última versão ' + nomePlataforma }}</span>
                  <ng-container *ngIf="linha.imagem; else valorTextualRevisao">
                    <img *ngIf="valor && valor !== '—' && !imagensComErro.has(valor); else semImagemRevisao"
                      [src]="valor" [alt]="lado === 0 ? 'Imagem do próximo envio' : 'Imagem publicada'" (error)="imagensComErro.add(valor)">
                    <ng-template #semImagemRevisao><span class="cv-muted">{{ valor && valor !== '—' ? 'Não foi possível carregar a imagem' : 'Sem imagem' }}</span></ng-template>
                  </ng-container>
                  <ng-template #valorTextualRevisao>
                    <details *ngIf="valor.length > 180; else textoCurtoRevisao"><summary>{{ valor.slice(0, 180) }}… <span class="cv-link">Ver completo</span></summary><p>{{ valor }}</p></details>
                    <ng-template #textoCurtoRevisao><p>{{ valor }}</p></ng-template>
                  </ng-template>
                </div>
                <div class="cv-review-change__result"><span class="cv-review-change__label">Próximo envio</span>
                  <span class="cv-review-result" [class.is-changed]="linha.alterada" [class.is-new]="linha.acao === 'Novo'">
                    {{ linha.alterada ? (linha.acao === 'Alterado' ? 'Será atualizado' : linha.acao) : 'Sem alteração' }}
                  </span>
                </div>
              </div>
            </div>
            <p class="cv-review-info" *ngIf="abasRevisao[item.produtoId] !== 'ADICIONAIS'"><i class="fa fa-info-circle" aria-hidden="true"></i> As diferenças estão destacadas. A publicação será revalidada antes do envio.</p>
          </ng-container>
        </section>
        <section class="cv-category-resolution" *ngIf="categoriaPendente(item) && produtoDaPrevia(item.produtoId) as produto">
          <strong>Categoria: {{ produto.categoria?.nome || 'Sem categoria' }}</strong>
          <p>Escolha como esta categoria será tratada no catálogo do {{ nomePlataforma }}.</p>
          <div class="cv-category-resolution__actions" *ngIf="produto.categoria">
            <select [(ngModel)]="categoriasExternasSelecionadas[produto.categoria.id]"
              [disabled]="categoriasExternasCarregando || categoriasResolvendo.has(produto.categoria.id)">
              <option value="">{{ categoriasExternasCarregando ? 'Consultando ' + nomePlataforma + '…' : 'Usar categoria existente…' }}</option>
              <option *ngFor="let categoria of categoriasExternas" [value]="categoria.id">
                {{ categoria.nome }}{{ categoria.status ? ' · ' + categoria.status : '' }}
              </option>
            </select>
            <button type="button" class="cv-button cv-button--outline"
              [disabled]="!categoriasExternasSelecionadas[produto.categoria.id] || categoriasResolvendo.has(produto.categoria.id)"
              (click)="resolvaCategoriaPrevia(item, 'EXISTENTE')">
              Usar existente
            </button>
            <button type="button" class="cv-button cv-button--primary"
              [disabled]="categoriasResolvendo.has(produto.categoria.id)"
              (click)="resolvaCategoriaPrevia(item, 'CRIAR')">
              Criar “{{ produto.categoria.nome }}” no {{ nomePlataforma }}
            </button>
          </div>
          <p *ngIf="categoriasExternasErro" class="cv-category-resolution__error">
            {{ categoriasExternasErro }}
            <button type="button" class="cv-link" (click)="carregueCategoriasExternas()">Tentar novamente</button>
          </p>
          <p *ngIf="!categoriasExternasCarregando && !categoriasExternasErro && !categoriasExternas.length">
            Nenhuma categoria existente foi encontrada no catálogo do {{ nomePlataforma }}.
          </p>
        </section>
      </article>
    </div>
    <footer>
      <div class="cv-review-footer-summary"><strong>{{ previaLote.total }} {{ previaLote.total === 1 ? 'item' : 'itens' }} em revisão · {{ idsPublicaveis.length }} {{ idsPublicaveis.length === 1 ? 'envio' : 'envios' }}</strong><span>Você pode revisar os detalhes antes de publicar.</span></div>
      <button type="button" class="cv-button cv-button--outline" (click)="revisaoAberta = false">Fechar revisão</button>
      <button type="button" class="cv-button cv-button--publish"
        [disabled]="!idsPublicaveis.length || publicando || salvandoPrecosRevisao || !publicacaoConfigurada || revisaoDesatualizada || !precosDaRevisaoConfirmados || carregandoDetalhesRevisao.size > 0 || categoriasResolvendo.size > 0"
        (click)="confirmePublicacao()">
        <i class="fa" [class.fa-upload]="!publicando" [class.fa-spinner]="publicando" [class.fa-spin]="publicando" aria-hidden="true"></i>
        {{ publicando ? 'Criando lote…' : ('Publicar ' + idsPublicaveis.length + ' envio(s)') }}
      </button>
    </footer>
    <p class="cv-modal__runtime" *ngIf="!publicacaoConfigurada">Processamento indisponível: nenhum lote será criado.</p>
  </section>
  <div class="cv-modal-backdrop cv-modal-backdrop--confirm-discard" *ngIf="confirmarDescarte" (click)="fecheDescartePendencias()"></div>
  <section class="cv-modal cv-modal--confirm-discard" *ngIf="confirmarDescarte" #modalCancelamentoPendencias
    role="dialog" aria-modal="true" aria-labelledby="cv-discard-title"
    aria-describedby="cv-discard-description" [attr.aria-busy]="descartandoPendencias"
    (keydown)="teclaCancelamentoPendencias($event)">
    <header>
      <h2 id="cv-discard-title">Cancelar pendências de adicionais?</h2>
      <button type="button" aria-label="Fechar confirmação" [disabled]="descartandoPendencias"
        (click)="fecheDescartePendencias()">×</button>
    </header>
    <div class="cv-modal__body" id="cv-discard-description">
      <p>{{ recursosParaCancelar.length }} alteração(ões) de adicionais selecionados serão canceladas e sairão da lista de revisão.</p>
      <p>Os produtos, o cadastro local e o {{ nomePlataforma }} não serão alterados. Uma nova edição poderá criar outra pendência.</p>
      <p class="cv-alert cv-alert--error" *ngIf="erroDescarte" role="alert">{{ erroDescarte }}</p>
    </div>
    <footer>
      <button type="button" class="cv-button cv-button--outline" data-voltar-cancelamento [disabled]="descartandoPendencias"
        (click)="fecheDescartePendencias()">Voltar</button>
      <button type="button" class="cv-button cv-button--danger"
        [disabled]="descartandoPendencias"
        (click)="descartePendencias()">
        <i class="fa" [class.fa-trash]="!descartandoPendencias" [class.fa-spinner]="descartandoPendencias"
          [class.fa-spin]="descartandoPendencias" aria-hidden="true"></i>
        {{ descartandoPendencias ? 'Cancelando…' : 'Sim, cancelar pendências' }}
      </button>
    </footer>
  </section>
  </fieldset>
</main>
